const ChevronUpIcon = ({ className = "w-6 h-6", ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.73467 15C5.96199 15 5.57503 14.0658 6.1214 13.5194L11.3868 8.25403C11.7255 7.91533 12.2746 7.91533 12.6133 8.25403L17.8788 13.5194C18.4251 14.0658 18.0382 15 17.2655 15H6.73467Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronUpIcon;
